<template>
  <div class="moderator-candidate-resumes-actions__sort">
    <div class="moderator-candidate-resumes-actions__label">{{ $tModeratorCandidates('Sort') }}</div>
    <BaseSelect v-model="sort"
                :options="options"
                :getOptionText="getOptionText"
                class="moderator-candidate-resumes-actions__sort-select  _white  _shadow"/>
  </div>
</template>

<script>
  const options = [{
    text: 'sort_by_id_asc',
    value: 'id_asc',
  }, {
    text: 'sort_by_id_desc',
    value: 'id_desc',
  }, {
    text: 'sort_by_created_at_asc',
    value: 'created_at_asc',
  }, {
    text: 'sort_by_created_at_desc',
    value: 'created_at_desc',
  }, {
    text: 'sort_by_all_passport_pages_asc',
    value: 'all_passport_pages_asc',
  }, {
    text: 'sort_by_all_passport_pages_desc',
    value: 'all_passport_pages_desc',
  }, {
    text: 'sort_by_have_sent_asc',
    value: 'have_sent_asc',
  }, {
    text: 'sort_by_have_sent_desc',
    value: 'have_sent_desc',
  }, {
    text: 'sort_by_checked_passport_asc',
    value: 'checked_passport_asc',
  }, {
    text: 'sort_by_checked_passport_desc',
    value: 'checked_passport_desc',
  }, {
    text: 'sort_by_have_interaction_asc',
    value: 'have_interaction_asc',
  }, {
    text: 'sort_by_have_interaction_desc',
    value: 'have_interaction_desc',
  }, {
    text: 'sort_by_questionnaire_status_asc',
    value: 'questionnaire_status_asc',
  }, {
    text: 'sort_by_questionnaire_status_desc',
    value: 'questionnaire_status_desc',
  }]

  export default {
    name: 'AMCandidatesResumesPageActionsSort',
    data() {
      return {
        options
      }
    },
    computed: {
      sort: {
        get() {
          const options = this.options
          const value = this.$route.query['sort']

          if (!value) return options[0]

          return options.find(o => o.value === value) || options[0]
        },
        set(value) {
          const query = JSON.parse(JSON.stringify(this.$route.query))
          query.sort = value.value

          this.$router.push({
            query
          }).catch(() => ({}))
        }
      }
    },
    methods: {
      getOptionText(option) {
        return this.$tModeratorCandidates(option.text)
      },
    }
  }
</script>

<style lang="less">

</style>
